"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.submittedStageTwo = void 0;
var Joi = require('joi').extend(require('@joi/date'));
exports.submittedStageTwo = Joi.object({
    amountOfCapitalization: Joi.number()
        .min(0)
        .max(9999999999999.99)
        .precision(2)
        .options({ convert: false })
        .when('capitalization', {
        is: true,
        then: Joi.number().required(),
        otherwise: Joi.number()
            .strip()
            .optional(),
    }),
    capitalization: Joi.boolean().optional(),
    capitalizationCalculateGrossDebtServiceRatioFrom: Joi.number()
        .min(0)
        .max(999.99)
        .precision(2)
        .options({ convert: false })
        .when('capitalization', {
        is: true,
        then: Joi.number().required(),
        otherwise: Joi.number()
            .strip()
            .optional(),
    }),
    capitalizationCalculateGrossDebtServiceRatioTo: Joi.number()
        .min(0)
        .max(999.99)
        .precision(2)
        .options({ convert: false })
        .when('capitalization', {
        is: true,
        then: Joi.number().required(),
        otherwise: Joi.number()
            .strip()
            .optional(),
    }),
    capitalizationCalculateTotalDebtServiceRatioFrom: Joi.number()
        .min(0)
        .max(999.99)
        .precision(2)
        .options({ convert: false })
        .when('capitalization', {
        is: true,
        then: Joi.number().required(),
        otherwise: Joi.number()
            .strip()
            .optional(),
    }),
    capitalizationCalculateTotalDebtServiceRatioTo: Joi.number()
        .min(0)
        .max(999.99)
        .precision(2)
        .options({ convert: false })
        .when('capitalization', {
        is: true,
        then: Joi.number().required(),
        otherwise: Joi.number()
            .strip()
            .optional(),
    }),
    capitalizationProposedMonthlyPaymentChangeFrom: Joi.number()
        .min(0)
        .max(9999999999999.99)
        .precision(2)
        .options({ convert: false })
        .when('capitalization', {
        is: true,
        then: Joi.number().required(),
        otherwise: Joi.number()
            .strip()
            .optional(),
    }),
    capitalizationProposedMonthlyPaymentChangeTo: Joi.number()
        .min(0)
        .max(9999999999999.99)
        .precision(2)
        .options({ convert: false })
        .when('capitalization', {
        is: true,
        then: Joi.number().required(),
        otherwise: Joi.number()
            .strip()
            .optional(),
    }),
    currentAmortizationPeriod: Joi.string()
        .min(0)
        .max(50)
        .when('extensionOfAmortizationPeriod', {
        is: true,
        then: Joi.string().required(),
        otherwise: Joi.string()
            .strip()
            .optional(),
    }),
    extendedMortgagePaymentDeferral: Joi.boolean().optional(),
    extensionOfAmortizationPeriod: Joi.boolean().optional(),
    interestOnlyPayment: Joi.boolean().optional(),
    interestOnlyPaymentAmount: Joi.number()
        .min(0)
        .max(9999999999999.99)
        .precision(2)
        .options({ convert: false })
        .when('interestOnlyPayment', {
        is: true,
        then: Joi.number().required(),
        otherwise: Joi.number()
            .strip()
            .optional(),
    }),
    interestOnlyPaymentDate: Joi.date()
        .max('12-31-9999')
        .when('interestOnlyPayment', {
        is: true,
        then: Joi.date().required(),
        otherwise: Joi.date()
            .strip()
            .optional(),
    }),
    newAmortizationPeriod: Joi.string()
        .min(0)
        .max(50)
        .when('extensionOfAmortizationPeriod', {
        is: true,
        then: Joi.string().required(),
        otherwise: Joi.string()
            .strip()
            .optional(),
    }),
    purposeOfFunds: Joi.string()
        .min(0)
        .max(500)
        .when('capitalization', {
        is: true,
        then: Joi.string().required(),
        otherwise: Joi.string()
            .strip()
            .optional(),
    }),
    specialPaymentArrangement: Joi.boolean().optional(),
    specialPaymentArrangementCalculateGrossDebtServiceRatioFrom: Joi.number()
        .min(0)
        .max(999.99)
        .precision(2)
        .options({ convert: false })
        .when('specialPaymentArrangement', {
        is: true,
        then: Joi.number().required(),
        otherwise: Joi.number()
            .strip()
            .optional(),
    }),
    specialPaymentArrangementCalculateGrossDebtServiceRatioTo: Joi.number()
        .min(0)
        .max(999.99)
        .precision(2)
        .options({ convert: false })
        .when('specialPaymentArrangement', {
        is: true,
        then: Joi.number().required(),
        otherwise: Joi.number()
            .strip()
            .optional(),
    }),
    specialPaymentArrangementCalculateTotalDebtServiceRatioFrom: Joi.number()
        .min(0)
        .max(999.99)
        .precision(2)
        .options({ convert: false })
        .when('specialPaymentArrangement', {
        is: true,
        then: Joi.number().required(),
        otherwise: Joi.number()
            .strip()
            .optional(),
    }),
    specialPaymentArrangementCalculateTotalDebtServiceRatioTo: Joi.number()
        .min(0)
        .max(999.99)
        .precision(2)
        .options({ convert: false })
        .when('specialPaymentArrangement', {
        is: true,
        then: Joi.number().required(),
        otherwise: Joi.number()
            .strip()
            .optional(),
    }),
    specialPaymentArrangementDateWhenAccountLastInCurrentPosition: Joi.date()
        .max('12-31-9999')
        .when('specialPaymentArrangement', {
        is: true,
        then: Joi.date().required(),
        otherwise: Joi.date()
            .strip()
            .optional(),
    }),
    specialPaymentArrangementEffectiveDateForProposedPaymentFrom: Joi.date()
        .max('12-31-9999')
        .when('specialPaymentArrangement', {
        is: true,
        then: Joi.date().required(),
        otherwise: Joi.date()
            .strip()
            .optional(),
    }),
    specialPaymentArrangementEffectiveDateForProposedPaymentTo: Joi.date()
        .max('12-31-9999')
        .when('specialPaymentArrangement', {
        is: true,
        then: Joi.date().required(),
        otherwise: Joi.date()
            .strip()
            .optional(),
    }),
    specialPaymentArrangementProposedMonthlyPaymentChangeFrom: Joi.number()
        .min(0)
        .max(9999999999999.99)
        .precision(2)
        .options({ convert: false })
        .when('specialPaymentArrangement', {
        is: true,
        then: Joi.number().required(),
        otherwise: Joi.number()
            .strip()
            .optional(),
    }),
    specialPaymentArrangementProposedMonthlyPaymentChangeTo: Joi.number()
        .min(0)
        .max(9999999999999.99)
        .precision(2)
        .options({ convert: false })
        .when('specialPaymentArrangement', {
        is: true,
        then: Joi.number().required(),
        otherwise: Joi.number()
            .strip()
            .optional(),
    }),
    totalDeferredAmount: Joi.number()
        .min(0)
        .max(9999999999999.99)
        .precision(2)
        .options({ convert: false })
        .when('extendedMortgagePaymentDeferral', {
        is: true,
        then: Joi.number().required(),
        otherwise: Joi.number()
            .strip()
            .optional(),
    }),
    totalMonthsDeferred: Joi.number()
        .min(0)
        .max(999.99)
        .precision(2)
        .options({ convert: false })
        .when('extendedMortgagePaymentDeferral', {
        is: true,
        then: Joi.number().required(),
        otherwise: Joi.number()
            .strip()
            .optional(),
    }),
});
exports.default = { submittedStageTwo: exports.submittedStageTwo };
